interface Props {
  text: string
  className?: string
}

export const SubTitle: React.FC<Props> = ({ text, className = '' }) => {
  return (
    <div className={`text-lg font-medium text-black ${className}`}>{text}</div>
  )
}
